import { createSelectors } from '@trg/utils';
import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

type PopupStore = {
  isWebChatOpen: boolean;
};

type PopupAction = {
  setWebChatOpen: (isWebChatOpen: boolean) => void;
};

type PopupState = PopupStore & PopupAction;

const usePopupStoreBase = create<PopupState>()(
  devtools(
    (set) => ({
      isWebChatOpen: false,
      setWebChatOpen: (isWebChatOpen: boolean) => set({ isWebChatOpen }),
    }),
    {
      name: 'popup',
      enabled: process.env.NODE_ENV === 'development',
    }
  )
);

export const usePopupStore = createSelectors(usePopupStoreBase);
